import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { firestore } from "../../index";
import {
  AboutLeader,
  defaultAboutLeaders,
  normalizeAboutLeader,
  sortAboutLeaders,
} from "./about_data";

export default function useAboutLeaders() {
  const [leaders, setLeaders] = useState<AboutLeader[]>(sortAboutLeaders(defaultAboutLeaders));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLeaders() {
      try {
        const snapshot = await getDocs(collection(firestore, "about_leadership"));

        if (!snapshot.docs.length) {
          setLeaders(sortAboutLeaders(defaultAboutLeaders));
          return;
        }

        setLeaders(
          sortAboutLeaders(
            snapshot.docs.map((leaderDoc) =>
              normalizeAboutLeader({
                docId: leaderDoc.id,
                ...(leaderDoc.data() as Omit<AboutLeader, "docId">),
              }),
            ),
          ),
        );
      } catch (error) {
        console.error("Failed to load about leaders", error);
        setLeaders(sortAboutLeaders(defaultAboutLeaders));
      } finally {
        setLoading(false);
      }
    }

    fetchLeaders();
  }, []);

  return {
    leaders,
    loading,
  };
}
